import React from 'react';
import Header from '../../components/header1/Header1';
import bannerImage from '../../elements/hero-banner-login-page.png';
import { useNavigate } from 'react-router-dom';


    

const RegistrationConfirmation = () => {

    const navigate = useNavigate();

    const handleHomeButtonClick = () => {
        navigate('/login');
    };

    return (
        <div className="confirmation">

            {/* <div className="banner">
                <img
                    src={bannerImage}
                    alt="Banner"
                />
            </div> */}

            <div className=" flex items-center justify-center h-1/2">
                <div className="bg-white p-8 max-w-md text-center">
                    <h1 className="text-3xl font-bold text-blue-600 mb-2">Your registration has been successfully confirmed.</h1>
                    <p className="text-blue-500 mb-4 font-normal">
                        Your registration no is {localStorage.getItem('student_id')} and you will receive login credentials via email shortly
                    </p>
                    <p><a
                        href="/dashboard"
                        className="bg-blue-600 text-white font-semibold py-2 px-4 rounded hover:bg-blue-500 transition duration-300 hidden"
                        onClick={handleHomeButtonClick} 
                    >
                        Go to Home
                    </a></p>
                    <a
                        href="/reset"
                        className="text-blue-500 hover:underline cursor-pointer hidden"
                    >
                        Reset Password?
                    </a>
                </div>
            </div>
        </div>
    );
};

export default RegistrationConfirmation;
